import { Injectable } from '@angular/core';
import { TableLazyLoadEvent } from 'primeng/table';
import { FilterInfo } from 'src/app/backend-client/models/Backend/Core/Api/Models/filter-info';
import { QueryRequest } from 'src/app/backend-client/models/Backend/Core/Api/Models/query-request';
import { MxMatchMode } from '.';

@Injectable({
  providedIn: 'root',
})
export class MxQueryService {
  constructor() {}

  static getQueryRequest(
    lazyLoadEvent: TableLazyLoadEvent,
    defaultSort: string,
    globalFilterColumns: string[],
    filterInfo: FilterInfo[] = []
  ): QueryRequest {
    return {
      skip: lazyLoadEvent ? lazyLoadEvent.first : 0,
      take: lazyLoadEvent ? lazyLoadEvent.rows : 0,
      filter: filterInfo,
      globalFilter: lazyLoadEvent.globalFilter
        ? globalFilterColumns.map((m) => {
            return {
              selector: m,
              matchMode: MxMatchMode.Contains,
              value: lazyLoadEvent.globalFilter as string,
            };
          })
        : null,
      defaultSort: defaultSort,
      sort: lazyLoadEvent.sortField
        ? [
            {
              desc: lazyLoadEvent.sortOrder === -1,
              selector: lazyLoadEvent.sortField as string,
            },
          ]
        : null,
    };
  }

  static getQueryResponseResult(result: any): {
    data: any[];
    totalRecords: number;
  } {
    return {
      data: result.items,
      totalRecords: result.recordCount,
    };
  }
}
